import { useSession } from "src/components/session/session";
import { useCreateJoinRequestMutation } from "src/gql/codegen/duneGraphql";
import dunegql from "src/utils/dunegqlCodegen/dunegql";

export function useSendJoinRequest() {
  const session = useSession();
  const [mutation, { loading }] = useCreateJoinRequestMutation({
    context: { session },
  });
  return { mutation, loading };
}

dunegql`
  mutation CreateJoinRequest($teamId: Int!) {
    requestToJoinTeam(teamId: $teamId) {
      id
      userId
      teamId
      status
      role
    }
  }
`;
